/* lua.js generated code 0.3.0 */

var fileExtension = ".ds"
LocalDataFiles = table(
    [1, "kGlobalLogin", "login" + fileExtension],
    [1, "kDefaultConfig", "config" + fileExtension],
    [1, "kRecommendData", "recommend" + fileExtension],
    [1, "kLastLoginOauth", "last_login" + fileExtension],
    [1, "kSnsUserInfo", "sns_info" + fileExtension],
    [1, "kUserData", "user" + fileExtension],
    [1, "kUserScore", "user_score" + fileExtension],
    [1, "kRecall", "recallInfo" + fileExtension],
    [1, "kNotification", "notification" + fileExtension],
    [1, "kLocalSettings", "settings" + fileExtension],
    [1, "kGameGuideRec", "guiderec" + fileExtension],
    [1, "kUserShare", "user_share" + fileExtension],
    [1, "kPaymentInfo", "payments" + fileExtension],
    [1, "kNewTeamGetStar", "new_team_get_star" + fileExtension],
    [1, "kGamePlayCache", "game_play_cache" + fileExtension],
    [1, "kWeekGameLevelData", "week_game_level_data" + fileExtension],
    [1, "kEnterPopoutQueue", "enter_game_popout" + fileExtension],
    [1, "kSeedInfo", "game_seed_info" + fileExtension],
    [1, "kUserTagInfo", "user_tag" + fileExtension],
    [1, "kKeepGameClicked", "keep_game_clicked" + fileExtension],
    [1, "kMarkPriseWxClicked", "mark_prise_wx_clicked" + fileExtension],
    [1, "kGetCountNoShare", "get_count_no_share" + fileExtension],
    [1, "kPassLevelShowoffFirst", "pss_level_showoff_first" + fileExtension],
    [1, "kGameboardSpeedSelect", "gameboard_speed_select" + fileExtension],
    [1, "kDc4UserPortrait", "dc_userportrait_last_time" + fileExtension],
    [1, "kPravacyMark", "pravacy_mark" + fileExtension],
    [1, "kVerifiedData", "verified" + fileExtension]
    [1, "kDropAdjustData", "drop_adjust_data" + fileExtension],
    [1, "kDropAdjustDataV2", "drop_adjust_data_v2" + fileExtension],
    [1, "kQualifyGameCache", "qualify_game_cache" + fileExtension],

)
LocalUserDataFiles = table(
    [0, LocalDataFiles.kDefaultConfig],
    [0, LocalDataFiles.kRecommendData],
    [0, LocalDataFiles.kLastLoginOauth],
    [0, LocalDataFiles.kSnsUserInfo],
    [0, LocalDataFiles.kUserData],
    [0, LocalDataFiles.kUserScore],
    [0, LocalDataFiles.kLocalSettings],
    [0, LocalDataFiles.kGameGuideRec],
    [0, LocalDataFiles.kUserShare],
    [0, LocalDataFiles.kNewTeamGetStar],
    [0, LocalDataFiles.kGamePlayCache],
    [0, LocalDataFiles.kWeekGameLevelData],
    [0, LocalDataFiles.kEnterPopoutQueue],
    [0, LocalDataFiles.kSeedInfo],
    [0, LocalDataFiles.kUserTagInfo],
    [0, LocalDataFiles.kKeepGameClicked],
    [0, LocalDataFiles.kGetCountNoShare],
    [0, LocalDataFiles.kMarkPriseWxClicked],
    [0, LocalDataFiles.kPravacyMark],
    [0, LocalDataFiles.kPassLevelShowoffFirst],
    [0, LocalDataFiles.kGameboardSpeedSelect],
    [0, LocalDataFiles.kDc4UserPortrait],
    [0, LocalDataFiles.kVerifiedData]
)
NeedTransferFiles = table([1, LocalDataFiles.kLocalSettings, "UserLocalSettings"], [1, LocalDataFiles.kGameGuideRec, "GameGuideData"])
